var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"hub"}},[_c('Filters'),_c('List')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }